import Dataset from './Dataset';

export type ModeType = 'map' | 'table';

export default Dataset;
